import './EditDecisionMakerSet.scoped.scss'
import { useAct } from 'FlowBuilder/store'
import isValidEmail from 'Shared/functions/validateEmail'

export default function EditDecisionMakerSet() {
  const act = useAct()
  const decisionMakersSet = useSel(s => s.decisionMakersSet)

  const [newDecisionMakerDetails, setNewDecisionMakerDetails] = useState({ email: '', name: '' })
  const [hideNewDecisionMaker, setHideNewDecisionMaker] = useState(true)

  const saveNewDecisionMaker = () => {
    if (newDecisionMakerDetails.email && newDecisionMakerDetails.name && isValidEmail(newDecisionMakerDetails.email)) {
      act.decisionMakersSet.upsertDecisionMaker(newDecisionMakerDetails.email, newDecisionMakerDetails.name)
      setNewDecisionMakerDetails({ email: '', name: '' })
    }
    if (hideNewDecisionMaker) {
      setHideNewDecisionMaker(false)
    }
  }
  const removeDecisionMaker = (email) => {
    act.decisionMakersSet.removeDecisionMaker(email)
  }

  const emailIsInDmSetAlready = (email) => {
    return !decisionMakersSet.decisionMakers.some(dm => dm.email === email)
  }

  const newEmailIsBad = () => {
    return (newDecisionMakerDetails?.email && !isValidEmail(newDecisionMakerDetails?.email)) ||
      (newDecisionMakerDetails?.email && !emailIsInDmSetAlready(newDecisionMakerDetails?.email)) ||
      (newDecisionMakerDetails?.name && !newDecisionMakerDetails?.email)
  }
  const newNameIsBad = () => {
    return (newDecisionMakerDetails?.email && !newDecisionMakerDetails?.name)
  }

  const saveButtonDisabled = !decisionMakersSet.decisionMakers ||
    decisionMakersSet.decisionMakers.length == 0 ||
    !decisionMakersSet.name ||
    newEmailIsBad() ||
    newNameIsBad()

  function onUpdate() {
    if (newDecisionMakerDetails.email) {
      saveNewDecisionMaker()
    }
    act.decisionMakersSet.commit()
    act.local.closeModal()
  }

  return <div>
    <div className="decision-maker-set-details">
      <span className='field'>
        <label className='bold'>
          List name
        </label>
        <input
          type="text"
          value={decisionMakersSet.name || ''}
          onChange={e => act.decisionMakersSet.setName(e.target.value)}
          className="input margin-bottom"
        />
      </span>
    </div>
    <div className="decision-makers">
      {decisionMakersSet.decisionMakers.map((dm, idx) => (
        <div className="decision-maker-row" key={idx}>
          <input
            type="email"
            placeholder="Email"
            value={dm.email || ''}
            onChange={e => act.decisionMakersSet.setDecisionMakerEmail(dm.email, e.target.value)}
            className={
              "input" + (newDecisionMakerDetails.email == dm.email ? " error" : "")
            }
          />
          <input
            type="text"
            placeholder="Name"
            value={dm.name || ''}
            onChange={e => act.decisionMakersSet.setDecisionMakerName(dm.email, e.target.value)}
            className="input"
          />
          <button
            type="button"
            className="button bigger-text icon-button"
            onClick={() => removeDecisionMaker(dm.email)}
            title="Remove"
          >
            &times;
          </button>
        </div>
      ))}
      {!hideNewDecisionMaker && 
        <div className="decision-maker-row new-decision-maker">
          <input
            type="email"
            placeholder="Email"
            value={newDecisionMakerDetails.email || ''}
            onChange={e => setNewDecisionMakerDetails({ ...newDecisionMakerDetails, email: e.target.value })}
            className={
              "input" + (newEmailIsBad() ? " error" : "")
            }
          />
          <input
            type="text"
            placeholder="Name"
            value={newDecisionMakerDetails.name || ''}
            onChange={e => setNewDecisionMakerDetails({ ...newDecisionMakerDetails, name: e.target.value })}
            className={
              "input" + (newNameIsBad() ? " error" : "")
            }
          />
          <button
            type="button"
            className="button bigger-text icon-button"
            onClick={() => {
              setNewDecisionMakerDetails({ email: '', name: '' })
              setHideNewDecisionMaker(true)
            }}
            title="Remove"
          >
            &times;
          </button>
        </div>
      }
    </div>
    <button
      type="button"
      className="button secondary margin-top half small"
      onClick={saveNewDecisionMaker}
      disabled={newEmailIsBad() || newNameIsBad()}
      title="Add"
    >
      Add recipient
    </button>
    <div className='row'>
      <div className='column remaining'>
        <button className='button primary margin-top' onClick={onUpdate} disabled={saveButtonDisabled}>Save</button>
      </div>
    </div>
  </div>
}



